/* eslint-disable */

import easydropdown from 'easydropdown'
export default el => {
  $(window).load(() => {
    //FIXME: this is hacky waiting for the color - option to be added to the selector via product.liquid jquery
    setTimeout(() => {
      const selectors = el.querySelectorAll('.selector-wrapper')
      if (selectors.length >= 1) {
        selectors.forEach(selectParent => {
          if (selectParent.classList.contains('edd-wrapper')) {
            const sel = selectParent.querySelector('select')
            sel && easydropdown(sel, {
              behavior: {
                useNativeUiOnMobile: false
              }
            })
          }
        })
      }
    }, 500)
  })
}





// WEBPACK FOOTER //
// ./src/scripts/components/pdp-dropdown.js